import AnimatedBackground from './AnimatedBackground';

export default function Footer() {
  return (
    <footer className="relative w-full bg-background-950 border-t border-background-300/10 overflow-hidden">
      {/* Section transition marker */}
      <div className="absolute top-0 left-0 right-0 flex items-center justify-center gap-3 z-20">
        <div className="w-10 h-[1px] bg-gradient-to-r from-transparent to-accent-500/20"></div>
        <div className="w-1 h-1 rounded-full bg-accent-500/25"></div>
        <div className="w-10 h-[1px] bg-gradient-to-l from-transparent to-accent-500/20"></div>
      </div>

      {/* Subtle grid */}
      <AnimatedBackground mode="grid" density={20} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="mt-12 pt-8 border-t border-background-300/10 flex items-center justify-center">
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            &copy; {new Date().getFullYear()} Generative Tech Limited. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}